<template>
  <div class="p-col-12" v-if="accessCode && protocolNumber >= 50">

    <public-header-component v-if="accessCode" title="forms.public-client.header-process" :accessCode="accessCode"/>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-lg-8" style="margin-left: auto; margin-right: auto;">
        <div class="card summary">
          <h3 class="title">Você está no PORTAL DO CLIENTE Ancestry Line!</h3>
          <span class="detail">
            Acompanhe o status de seu processo de forma fácil e transparente. Observe a barra de progresso e a linha do tempo abaixo para se atualizar sobre cada etapa.
            Estamos comprometidos em tornar essa jornada tranquila e enriquecedora, proporcionando uma experiência que você levará consigo por toda a vida.
          </span>
          <p>
            Se desejar entrar em contato com a nossa equipe?
          </p>
          <p>
            <img src="/email.jpg" alt="WhatsApp" style="width: 20px; vertical-align: middle; margin-left: 5px; margin-right: 5px;" /> <a href="mailto:contato@ancestryline.com.br" target="_blank">contato@ancestryline.com.br</a><br /><br />
            <img src="/instagram.png" alt="WhatsApp" style="width: 20px; vertical-align: middle; margin-left: 5px; margin-right: 5px;" /> <a href="https://www.instagram.com/ancestryline/" target="_blank">@ancestryline</a><br /><br />
            <img src="/whatsapp.png" alt="WhatsApp" style="width: 30px; vertical-align: middle; margin-right: 5px;" /> <a href="https://wa.me/+5548998569000?text=Olá, estou entrando em contato através do portal do cliente!" target="_blank">(48) 9 9856-9000</a><br />
          </p>
        </div>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-lg-8" style="margin-left: auto; margin-right: auto;">
        <div class="card summary">
          <h3 class="title">Seu grupo familiar é: '{{ protocolInfo.protocolGroupName }}'</h3>
          <span class="detail">
            No seu grupo familiar consta os seguintes membros:
          </span>
          <p>
            <ul>
              <li v-for="(person, index) in protocolInfo.persons" :key="index">
                {{ person.name }}
                <ul>
                  <li v-for="(dependendName, index) in person.dependents" :key="index">
                    {{ dependendName }}
                  </li>
                </ul>
              </li>
            </ul>
          </p>
        </div>
      </div>
    </div>

    <br />
    
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-lg-8" style="margin-left: auto; margin-right: auto;">
        <div class="card summary">
          <h3 class="title">Acompanhe o andamento do seu processo</h3>
          <h5 class="title">Esta barra de status considera as etapas desde o início do processo até o envio para o Ministério da Justiça de Luxemburgo.</h5>
          <ancestryline-progress-bar :value="protocolProgress" />
          <h4 class="sent" v-if="protocolProgress >= 100 && protocolInfo.sent">PARABÉNS! Seu dossiê foi 100% concluído e enviado para o Ministério da Jutiça de Luxemburgo</h4>
        </div>
      </div>
    </div>
  
    <div class="timeline">
      <div v-for="(timeline, index) in ModalTimeline" class="timeline__event  animated fadeInUp delay-3s" :class="timeline.cssColor" :key="index">
        <div class="timeline__event__icon ">
          <i class="lni-cake"></i>
          <div class="timeline__event__date">
            {{$d(new Date(timeline.displayDate), 'long')}}
          </div>
        </div>
        <div class="timeline__event__content ">
          <div class="timeline__event__title">
            {{ timeline.name }}
          </div>
          <div class="timeline__event__description">
            <p v-html="timeline.description"></p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import Utils from "@/utils/Utils";
import DialogService from "@/business/ModalBusiness";
import ModalCodeAccess from "@/viewer/public-client-form/ModalCodeAccess";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import PublicProtocolBusiness from "@/business/PublicProtocolBusiness";
import PublicHeaderComponent from "@/viewer/public-client-form/PublicHeaderComponent.vue";
import CertificateProtocolBusiness from "@/business/CertificateProtocolBusiness";
import EventBus from "@/commons/EventBus";

export default {
  name: "PublicClientProtocolInfo",
  components: {PublicHeaderComponent},

  data(){
    return {
      protocolId: null,
      accessCode: null,
      protocolNumber: 0,
      protocolInfo: {
        sent: false,
        checklist: [],
        timelines: [],
      },
    }
  },
  async mounted(){
    this.protocolId = this.$route?.params?.protocolId;
    if(this.protocolId){
      EventBus.loadingPage(true);
      this.accessCode = localStorage.getItem('accessCode');
      if(Utils.isEmptyNullOrUndefined(this.accessCode)) {
        await this.getAccessCode();
      } else {
        await this.loadProtocolInfo();
      }
      EventBus.loadingPage(false);
    }

    await this.loadProtocolNumber();
  },
  computed:{
    protocolProgress() {
      return this.calculateProgressCertificates(this.getAllCertificates(this.protocolInfo.checklist[0]));
    },
    ModalTimeline() {
      if (!this.protocolInfo.timelines) return [];
      return [...this.protocolInfo.timelines].filter(timeline => timeline.toDisplay).sort((a, b) => new Date(b.displayDate) - new Date(a.displayDate));
    }
  },
  methods:{

    calculateProgressCertificates: CertificateProtocolBusiness.calculateProgressCertificates,
    getAllCertificates: CertificateProtocolBusiness.getAllCertificates,

    async getAccessCode(){
      this.accessCode = await DialogService.openModal(ModalCodeAccess);
      if(Utils.isEmptyNullOrUndefined(this.accessCode)){
        await this.getAccessCode();
      }
      localStorage.setItem('accessCode', this.accessCode);
      await this.loadProtocolInfo();
    },

    async loadProtocolInfo() {
      this.protocolInfo = await PublicProtocolBusiness.getProtocolInformation(this.protocolId, this.accessCode).catch(async (e) => {
        ToastMessageBusiness.showError(e.message);
        this.accessCode = null;
        localStorage.removeItem('accessCode');
        await this.getAccessCode();
      });
    },

    async loadProtocolNumber() {
      const protocolNumber = await PublicProtocolBusiness.getProtocolNumber(this.protocolId, this.accessCode).catch(() => {
        this.protocolNumber = 0;
      });
      if (protocolNumber) {
        this.protocolNumber = protocolNumber;
      }
    },

  }
}
</script>

<style scoped lang="scss">

html {
  font-size: 14px;
}
body {
  background: #f6f9fc;
  font-family: "Open Sans", sans-serif;
  color: #525f7f;
}
h2{
  margin: 5%;
  text-align: center;
  font-size: 2rem;
  font-weight: 100;
}
.timeline {
  display: flex;
  flex-direction: column;
  width: 50vw;
  margin-right: auto;
  margin-bottom: 5%;
  margin-left: auto;

  &__event {
    background: #fff;
    margin-bottom: 20px;
    position: relative;
    display: flex;
    margin: 20px 0;
    border-radius: 8px;
    box-shadow: 0 30px 60px -12px rgba(50, 50, 93, 0.25),
      0 18px 36px -18px rgba(0, 0, 0, 0.3),
      0 -12px 36px -8px rgba(0, 0, 0, 0.025);

    &__title {
      font-size: 1.2rem;
      line-height: 1.4;
      text-transform: uppercase;

      font-weight: 600;
      color: #646464;
      letter-spacing: 1.5px;
    }
    &__content {
      padding: 20px;
    }
    &__date {
      color: #b4b4b4;
      font-size: 1.3rem;
      font-weight: 600;
      height: 8px;
      white-space: nowrap;
      display: flex;
      align-items: center;
    }
    &__icon {
      border-radius: 8px 0 0 8px;
      background: #646464;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-basis: 40%;
      font-size: 2rem;
      color: #646464;
      padding: 20px;

      i {
        position: absolute;
        top: 50%;
        left:-65px;
        font-size: 2.5rem;
      transform: translateY(-50%);
        
      }
    }
    &__description {
      flex-basis: 60%;
    }

    &:after {
      content: "";
      width: 2px;
      height: 100%;
      background: #646464;
      position: absolute;
      top: 52%;
      // transform: translateY(-50%);
      left: -3.5rem;
      z-index: -1;
      
    
    }

    &:before {
      content: "";
      width: 5rem;
      height: 5rem;
      position: absolute;
      background: #b4b4b4;
      border-radius: 100%;
      left: -6rem;
      // right: 90%;
      top: 50%;
      transform: translateY(-50%);
      border: 2px solid #646464;
    }
    &--type2 {
      &:before {
        background: #87bbfe;
        border-color: #555ac0;
      }
      &:after{
        background: #555ac0;
  
      }
      .timeline__event__date {
        color: #87bbfe;
      }

      .timeline__event__icon {
        background: #555ac0;
        color: #555ac0;
      }
      .timeline__event__title {
        color: #555ac0;
      }
    }

    &--type3 {
      &:before {
        background: #aff1b6;
        border-color: #24b47e;
      }
      &:after{
        background: #24b47e;
  
      }
      .timeline__event__date {
        color: #aff1b6;
      }

      .timeline__event__icon {
        background: #24b47e;
        color: #24b47e;
      }
      .timeline__event__title {
        color: #24b47e;
      }
    }
      &:last-child{

        &:after{
          content: none;
        }
    }
    
  }
}

.timeline__event {
  flex-direction: column;
}
.timeline__event__icon {
  border-radius: 4px 4px 0 0;
}

.sent{
  color: #3498DB;
  font-weight: bold;
  text-align: center;
}


</style>